export const MAX_STOPOVER_TIME = 1440; // in minutes, equivalent to 24 hr 
export const LONG_TRANSIT_TIME = 240; // in minutes, equivalent to 4 hr 
export const LAYOVER_TYPE_STOP = 'Stop';
export const LAYOVER_TYPE_STOPOVER = 'Stopover';
